export enum FiOnboardingReportGroupType {
    // todo do we need this  enum?
    Onboardings,
    ParticipantsOnboarded,
    RecentActivities,
}

export enum FiOnboardingReportType {
    Total = 0,
    Synchronised = 1,
    Independent = 2,
    ParticipantsOnboarded = 4,
    RecentActivities = 5,
}

export enum FiOnboardingReportWidgetType {
    // used only on frontend,

    // ac2 https://chainformation.atlassian.net/wiki/spaces/FI/pages/2683502593/Dashboard+Total+onboardings+Onboarding+overview+Locations+pages
    OnboardingCompletion,

    // ac3 https://chainformation.atlassian.net/wiki/spaces/FI/pages/2683502593/Dashboard+Total+onboardings+Onboarding+overview+Locations+pages
    OnboardingLocations,

    // ac1 https://chainformation.atlassian.net/wiki/spaces/FI/pages/2684518401/Onboarding+overview+Participants+Participant+progress+details+pages
    OnboardingParticipants,

    // ac1 https://chainformation.atlassian.net/wiki/spaces/FI/pages/2694512641/Total+participants+onboarded+widget
    ParticipantsOnboarded,

    // ac2 https://chainformation.atlassian.net/wiki/spaces/FI/pages/2684518401/Onboarding+overview+Participants+Participant+progress+details+pages
    OnboardingParticipantDetails,

    RecentActivities,
}

export enum FiOnboardingReportDateType {
    PastWeek = 1,
    PastMonth = 2,
    PastQuarter = 3,
    PastYear = 4,
    Custom = 100,
}
